import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import Icon from "backpack-ui/dist/components/icon";
import styles from "./styles.css";

const MenuLinkIcon = ({ expanded }) => (
  <Icon.ChevronDown
    className={cn(styles.linkIcon, expanded && styles.linkIconExpanded)}
  />
);

MenuLinkIcon.propTypes = {
  expanded: PropTypes.bool,
};

MenuLinkIcon.defaultProps = {
  expanded: false,
};

export default MenuLinkIcon;
